import DnsLeakTestIcon from 'images/organization/homepage/headerNavMenu/freeTools/dns-leak-test.svg'
import FreeDnsIcon from 'images/organization/homepage/headerNavMenu/freeTools/free-dns.svg'
import WebsiteLinkCheckerIcon from 'images/organization/homepage/headerNavMenu/freeTools/website-link-checker.svg'
import DnsRebindTestIcon from 'images/organization/homepage/headerNavMenu/freeTools/dns-rebind-test.svg'

export const freeTools = [
  {
    header: 'Free DNS',
    icon: FreeDnsIcon,
    description: 'Free and public DNS servers from Control D.',
    href: '/free-dns',
  },
  {
    header: 'Is This Link Safe?',
    icon: WebsiteLinkCheckerIcon,
    description: 'Determine whether a website is secure and free from malware.',
    href: '/tools/website-link-checker',
  },
  {
    header: 'DNS Leak Test',
    icon: DnsLeakTestIcon,
    description: "Check if you're leaking DNS requests.",
    href: '/tools/dns-leak-test',
  },
  {
    header: 'DNS Rebind Test',
    icon: DnsRebindTestIcon,
    description: 'Test your DNS security against rebinding attacks.',
    href: '/tools/dns-rebind-test',
  },
]
